"use strict";
// google-types.d.ts
Object.defineProperty(exports, "__esModule", { value: true });
// הוספות של calandarSync By Nechami Eitan
